export default __webpack_public_path__ + "static/gitex_thumb-cf45f00a840648955a4bc732e7bb62dc.png";